import { Component, OnInit } from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import { RouterLink, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-outlet-test',
    templateUrl: './outlet-test.component.html',
    styleUrls: ['./outlet-test.component.css'],
    imports: [RouterLink, RouterOutlet]
})
export class OutletTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
